import { render, staticRenderFns } from "./NavigatorQuizs.vue?vue&type=template&id=6f5d3fdd&scoped=true"
import script from "./NavigatorQuizs.vue?vue&type=script&lang=js"
export * from "./NavigatorQuizs.vue?vue&type=script&lang=js"
import style0 from "./NavigatorQuizs.vue?vue&type=style&index=0&id=6f5d3fdd&prod&scoped=true&lang=css"
import style1 from "./NavigatorQuizs.vue?vue&type=style&index=1&id=6f5d3fdd&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f5d3fdd",
  null
  
)

export default component.exports